// The person's Microsoft sign-in for SharePoint, as the app sees it. The Microsoft library itself (dist/microsoft.js)
// is loaded the first time it's needed. token() is quiet and fails when a sign-in window is needed; token({ interactive:
// true }) may open one, so it's only called straight from a click.
export function createMicrosoft(cfg, { email, load }) {
  const enabled = !!(cfg.msClientId && cfg.msTenantId);
  let client = null, loading = null;
  function ready() {
    if (client) return Promise.resolve(client);
    if (!loading) {
      loading = load("/microsoft.js")
        .then(() => window.PRECON_MSAL.create({ clientId: cfg.msClientId, tenantId: cfg.msTenantId, redirectUri: window.location.origin + "/auth-redirect.html" }))
        .then(c => (client = c))
        .catch(e => { loading = null; throw Object.assign(new Error("Microsoft sign-in couldn't start. Reload the page and try again."), { code: "microsoft_unavailable", cause: e }); });
    }
    return loading;
  }
  return {
    enabled,
    async token({ interactive = false } = {}) {
      if (!enabled) return null;
      // When the library is already loaded, ask straight away so a sign-in window still counts as part of the click.
      const c = client || await ready();
      return c.token({ email: await email(), interactive });
    },
    async clear() {
      if (!enabled) return;
      try { await (await ready()).clear(); } catch (e) { /* nothing to forget */ }
    },
  };
}
// Services whose requests carry the person's Microsoft token.
export const MICROSOFT_SERVICES = ["job-documents", "approval-forms"];
